import { AwaitContainer, Button, DialogRoot, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useHasPermission } from '@/entities/profile';
import { useReportKnowledgeNode } from '../model';

type Props = {
  nodeId?: number;
  onClose: () => void;
};

export const KnowledgeNodeDetailDialog: FC<Props> = ({ nodeId, onClose }) => {
  const { t } = useTranslation(['dialogs']);
  const { name, text, isLoading, path, permission } = useReportKnowledgeNode(nodeId);
  const canOpenSection = useHasPermission(permission);
  return (
    <DialogRoot open={!!nodeId} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`${t('expertReport.knowledgeNodeTitle')}: ${name}`}</DialogTitle>
        </DialogHeader>
        <AwaitContainer isLoading={isLoading}>
          <div className="whitespace-pre-wrap text-sm">{text}</div>
        </AwaitContainer>
        <DialogFooter className="flex items-center">
          {/* Переход ведёт в раздел, которому знание принадлежит, — без права на него само знание всё равно читается */}
          {canOpenSection && (
            <Link to={path} className="text-primary underline text-sm hover:text-primary/80">
              {t('expertReport.openCard')}
            </Link>
          )}
          <Button variant="outline" onClick={onClose}>
            {t('expertReport.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
